import r from "./_isArrayLike.js";
import o from "./values.js";
import e from "./_cb.js";
import t from "./each.js";
function f(f, n, i) {
  var l,
    m,
    u = 1 / 0,
    s = 1 / 0;
  if (null == n || "number" == typeof n && "object" != typeof f[0] && null != f) {
    f = r(f) ? f : o(f);
    for (var a = 0, p = f.length; a < p; a++) null != (l = f[a]) && l < u && (u = l);
  } else n = e(n, i), t(f, function (r, o, e) {
    ((m = n(r, o, e)) < s || m === 1 / 0 && u === 1 / 0) && (u = r, s = m);
  });
  return u;
}
export { f as default };